function accordionAnchorExpand() {
  let anchor = window.location.hash.replace('#', '');
  if (anchor) {
    let anchorElement = document.getElementById(anchor);
    if (anchorElement) {
      let accordionCollapsedButton = anchorElement.querySelector('.accordion-button.collapsed');
      if (accordionCollapsedButton) {
        accordionCollapsedButton.click();
        setTimeout(
          function () { anchorElement.scrollIntoView(true) },
          300
        );
      }
    }
  }
}

function accordionAnchorSet() {
  let accordionHeaders = document.querySelectorAll('.accordion-header');
  accordionHeaders.forEach(accordionHeader => {
    let accordionButton = accordionHeader.querySelector('.accordion-button');
    if (accordionButton) {
      accordionButton.addEventListener('click', event => {
        window.location.hash = accordionHeader.id;
      });
    }
  });
}

function anchorClickExpandAccordion() {
  let anchors = document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', event => {
      let accordionHeader = document.querySelector(`${anchor.getAttribute('href')}.accordion-header`);
      if (accordionHeader) {
        let accordionButton = accordionHeader.querySelector('.accordion-button');
        if (accordionButton.getAttribute('aria-expanded') == 'false') {
          accordionButton.click();
        }
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  accordionAnchorExpand();
  accordionAnchorSet();
  anchorClickExpandAccordion();
});